import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SchoolSignupStore {

}

export enum SchoolSignupStoreKeys {

}
